import React from 'react';
import styled from 'styled-components';

// --- STYLED COMPONENTS ---

const MapWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 5px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const AddressHeader = styled.div`
  // margin-bottom: 15px;
  
  h3 {
    // margin: 0 0 5px 0;
    color: #0c2340;
    font-size: 1.25rem;
  }
  
  p {
    margin: 0;
    color: #555555;
    font-size: 0.95rem;
  }
`;

const ResponsiveIframeContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  border-radius: 8px;
  border: 1px solid #e2e8f0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

// --- MAIN COMPONENT ---

const MapEmbed = ({embedUrl,address}) => {
  // Encoded address string for the Google Maps Embed URL query
  
 

  return (
    <MapWrapper>
      <AddressHeader>
        {/* <h3>Location Base</h3> */}
        <p>{address}</p>
      </AddressHeader>
      
      <ResponsiveIframeContainer>
        <iframe
          title="Google Map Embed"
          src={embedUrl}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </ResponsiveIframeContainer>
    </MapWrapper>
  );
};

export default MapEmbed;